import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import DisplayContainer from "../../../../components/displayContainer/DisplayContainer";
import ImageUploader from "../../../../components/inputs/imageUploader/ImageUploader";
import Loader from "../../../../components/loader/Loader";
import TextWrapper from "../../../../components/textWrapper/TextWrapper";
import { fetchRegionImages } from "../../../../features/images/regionImages/regionImagesSlice";
import styles from "./regionImages.module.css";
import RegionOneImage from "./regionOneImage/RegionOneImage";

const RegionImages = () => {
  const dispatch = useDispatch();
  const {
    fetchStatus,
    deleteStatus,
    list: regionImages,
    uploadStatus,
  } = useSelector((state) => state.regionImages);

  useEffect(() => {
    if (fetchStatus === "idle") {
      dispatch(fetchRegionImages());
    }
  }, [dispatch, fetchStatus]);

  if (
    fetchStatus === "loading" ||
    deleteStatus === "loading" ||
    uploadStatus === "loading"
  ) {
    return (
      <div className={styles.loaderContainer}>
        <Loader />
      </div>
    );
  }

  return (
    <div className={styles.container}>
      <div className={styles.headerRow}>
        <TextWrapper textStyle="textTitle">جميع صور المناطق</TextWrapper>
        <div className={styles.imageUploaderWrapper}>
          <ImageUploader tag={"region"} label="رفع صورة جديدة" />
        </div>
      </div>
      <div className={styles.allImagesWrapper}>
        <DisplayContainer className={styles.imagesDisplay}>
          {regionImages.map((item) => {
            return (
              <RegionOneImage
                key={item._id}
                path={item.path}
                name={item.name}
                id={item._id}
              />
            );
          })}
        </DisplayContainer>
      </div>
    </div>
  );
};

export default RegionImages;
